import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography, FormControl, Box, FormLabel, FormGroup, RadioGroup, Radio, FormControlLabel, Checkbox } from '@mui/material';
import FilterIcon from '@mui/icons-material/FilterList';
import { useSelector, useDispatch } from 'react-redux';
import { get, set, orderBy } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { UserFilter } from 'global/utils/filter';
import { UserStatus, UserPermission } from 'global/lib/filter';
import { useScreen } from 'global/styles';
import useStyles from 'global/styles/filters';
import DiagContainer from 'global/components/diag-container';
import setUserRealm from 'redux/actions/userRealm';
import useRetrieveData from 'global/hooks/useRetrieveData';

export default function PerformTasksFilters({ display, vendors }) {
  const [showFilters, setShowFilters] = useState(false);
  const filter = useSelector((state) => get(state, `filter.users.manage`, UserFilter()));
  const authrealm = useSelector((state) => get(state, 'auth.realm'));
  const realmid = useSelector((state) => get(state, 'auth.realm.id'));
  const dispatch = useDispatch();
  const { status, permission, user_group_id } = filter; // realm_type,

  const { isMobile } = useScreen();

  const classes = useStyles({ isMobile });

  const userGroups = useRetrieveData({ url: `/user-groups` }, { 
    build: ['userGroups'],
    transformData: d => {
      return orderBy(d, 'name');
    }
  });

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const foundInVendors = get(vendors, 'data', []).find((v) => `${v.clientId}` === `${get(authrealm, 'topRealm.id')}`);
    if (foundInVendors && get(filter, 'client_id') !== foundInVendors.id) {
      changeFilter(set({ ...filter }, 'client_id', foundInVendors.id));
    } else if (!!get(filter, 'client_id') && !authrealm) {
      changeFilter(set({ ...filter }, 'client_id', null));
    }
  }, [realmid, authrealm]);

  const changeFilter = (filt) => {
    dispatch(setFilter('users', 'manage', filt));
  };

  const handleStatusChange = (e) => {
    changeFilter(set({ ...filter }, `status`, e.target.value));
  };

  const handlePermissionChange = (name) => (e) => {
    const exists = permission.indexOf(name);
    const filt = { ...filter };
    if (exists !== -1) {
      filt.permission.splice(exists, 1);
    } else {
      filt.permission.push(name);
    }
    changeFilter(filt);
  };

  const handleGroupChange = (name) => (e) => {
    const exists = user_group_id.indexOf(name);
    const filt = { ...filter };
    if (exists !== -1) {
      filt.user_group_id.splice(exists, 1);
    } else {
      filt.user_group_id.push(name);
    }
    changeFilter(filt);
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  return (
    <Box sx={{
      displayPrint: "none"
    }}>
      <div className={classes.grid}>
        {isMobile && (
          <Button aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" className={classes.icon} /> {showFilters ? 'Hide Filters' : 'Filters'}
          </Button>
        )}

        <DiagContainer useDialog={isMobile} onClose={toggleFilters} open={showFilters}>
          <Typography variant="overline">Filters</Typography>

          <form autoComplete="off" margin="normal" className={classes.form}>
            <Grid container>
              <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel component="legend">Status</FormLabel>
                    <RadioGroup size="small" value={status} onChange={(e) => handleStatusChange(e)}>
                      {UserStatus.map((ed, i) => (
                        <FormControlLabel key={i} control={<Radio />} label={ed.title} value={ed.value} />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              </Grid>

              <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel component="legend">Permission</FormLabel>
                    <FormGroup>
                      {UserPermission.map((ed, i) => (
                        <FormControlLabel key={i} control={<Checkbox checked={permission.indexOf(ed.value) > -1} onChange={handlePermissionChange(ed.value)} value={ed.value} />} label={ed.title} />
                      ))}
                    </FormGroup>
                  </FormControl>
                </div>
              </Grid>

              <Grid item md={12} className={classes.formGrid}>
                <div className={classes.flexFilters}>
                  <FormControl component="fieldset" className={classes.formItem}>
                    <FormLabel component="legend">User Group</FormLabel>
                    <FormGroup>
                      {userGroups.data.map((ed, i) => (
                        <FormControlLabel key={i} control={<Checkbox checked={user_group_id.indexOf(ed.id) > -1} onChange={handleGroupChange(ed.id)} value={ed.id} />} label={ed.name} />
                      ))}
                    </FormGroup>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </form>
        </DiagContainer>
      </div>
    </Box>
  );
}
